import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { WorkMaterialStatus } from './work-material-status.interface';

export class WorkMaterialStatusService {
   async getWorkMaterialStatuses() {
      return await http
         .get<ApiResource<Array<WorkMaterialStatus>>>(`/work-material-statuses`, cacheFirstConfig)
         .then((response) => response.data);
   }
}
